export const subsiteTexts = [
  {
    text: "We do your dirty work and make it look clean for you.",
    fontSize: "27px",
    fontWeight: "700",
  },
  {
    text: "Find out how much time and money you'll save by sharing your needs with our team, who will bespoke a solution.",
    fontSize: "16px",
    fontWeight: "200",
  },
  {
    text: "Our ecological and economical solutions unlock unique time and money savings for you.",
    fontSize: "17px",
    fontWeight: "500",
  },
];
export const defaultTickeType = {
  active: true,
  layers: [{ type: "" }],
};



// WEBPACK FOOTER //
// ./src/screens/Tasks/constants/default.js